import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, Injector, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { AccessoryCategory, Constants, Positions, PositionValues } from '../core/Constants';
import { BRAND } from '../core/DI';
import { GenericSummaryCardDtoResponse } from '../core/models/generic-summary-card.dto-response';
import { HardwareCategoryCards } from '../core/models/hardware-category-cards';
import { MakeYearModel } from '../core/models/make-year-model.model';
import { PackageBuilderSelections } from '../core/models/package-builder-selections.model';
import { PackageBuilderSummaryProduct } from '../core/models/package-builder-summary-product.model';
import { PageModel } from '../core/models/page.model';
import { Product } from '../core/models/product.model';
import { RouteContext } from '../core/models/route-context';
import { StaggeredPackageBuilderModel } from '../core/models/staggered-package-builder.model';
import { VehicleOemDataDtoResponse } from '../core/models/vehicule-oem-data.dto-response';
import { User } from '../core/User';
import { PackageBuilderConstants } from '../package-builder/model/package-builder-constants';
import { HardwareService } from '../shared/hardware.service';
import { CardChangedEventArgs } from '../shared/hardwares/hardware-details-modal/hardware-details-modal.component';
import { Helper } from '../shared/helper';
import { PackageBuilderFlow } from './model/package-builder-flow.enum';
import { PackageBuilderService } from './package-builder.service';
import { take } from 'rxjs/operators';
import { state } from '@angular/animations';
import { Session } from 'protractor';
//djb-use jquery for tab flow
//import * as $ from 'jquery';

@Component({
  selector: 'app-package-builder',
  templateUrl: './package-builder.component.html',
  styleUrls: ['./package-builder.component.css']

})

export class PackageBuilderComponent implements OnInit, OnDestroy {
  @Input() itemCount: number;
  cards = new Array<GenericSummaryCardDtoResponse>(); // GenericSummaryCardDtoResponse[];
  //context = RouteContext.NONE;
  separatedProducts: HardwareCategoryCards[];
  visibility = {};
  recommendedView = true;

  //@Input() card: GenericSummaryCardDtoResponse;
  @Output() change = new EventEmitter();

  flow: 0;
  searchResult: string;
  wheelsRoute: string;
  tiresRoute: string;
  hardwaresRoute: string;
  summaryRoute: string;
  packagekitsRoute: string;
  tireLinkDisabled = true;
  studdingLinkDisabled = true;
  wheelLinkDisabled = false;
  hardwareLinkDisabled = true;
  summaryLinkDisabled = true;
  kitLinkDisabled = false;
  frontSelections = new PackageBuilderSelections();
  rearSelections = new PackageBuilderSelections();
  frontSelectionsOnSaleAtDealerCost = new PackageBuilderSelections();
  rearSelectionsOnSaleAtDealerCost = new PackageBuilderSelections();
  currentMyM: MakeYearModel;
  currentWheelStagger: string;
  currentTireStagger: string;
  defaultWheelStagger: string;
  defaultTireStagger: string;
  isReady: boolean;
  wheelType: string;
  tireType: string;
  labourType: string;
  hardwareType: string;
  packagekitType: string;
  isInB2b: boolean;
  currentWheelSizeSelected: string;
  tiresFirst: boolean;
  public pbFlow = 0;

  url: string;
  firstSummaryChange = false;
  productChanged = false;
  oemData = new VehicleOemDataDtoResponse();
  showTabs = false;
  nutLocalisationKey: string = "FC.PackageBuilder.Nuts";

  // djb:breaking listener change in old ng, also to prevent memory leaks
  listenFunc: Function;
  subs: Subscription[] = [];

  private id: string;
  private appliedFilters = { tireFilters: {}, wheelFilters: {} };

  constructor(private injector: Injector,
    private translate: TranslateService,
    private hardwareService: HardwareService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private packageBuilderService: PackageBuilderService,
    private renderer: Renderer2,
    @Inject(BRAND) brand: string) {
    (<any>window).inPackageBuilder = true;
    User.setTranslation(this.translate);
    this.listenFunc = renderer.listen('document', 'savePackage', (event) => {
      // djb:i18n-language change step1, triggered by Kentico menu
      //this.log(`savePackage state in session`);
      //sessionStorage.setItem('pbProducts', JSON.stringify(this.packageBuilderService.getPackageBuilderModel()));
      //sessionStorage.setItem('pbFlow', JSON.stringify(this.packageBuilderService.getPackageBuilderFlow()));
      //sessionStorage.setItem('frontSummaries', JSON.stringify(this.frontSelections));
      //sessionStorage.setItem('rearSummaries', JSON.stringify(this.rearSelections));
      //sessionStorage.setItem('pbOEMData', JSON.stringify(this.packageBuilderService.getPackageBuilderOEMData()));
      //sessionStorage.setItem('pbCards', JSON.stringify(this.cards));
      // djb:i18n-step2 signal Kentico to redirect to new page
      User.dispatchEvent('refreshKentico', 'saved package, inform Kentico parent');
    });
    this.isInB2b = brand === Constants.BRAND_B2B;
    if (!this.isInB2b) {
      this.log("router.navigate" + this.wheelsRoute);
      this.navigate([this.wheelsRoute], { queryParamsHandling: 'merge', relativeTo: this.route });
    }
    this.id = Helper.generateId(1);
    this.log(`constructor`);
  }

  get showDealerPrice(): boolean {
    return User.showDealerPrice;
  }

  ngOnInit() {
    this.log('OnInit');
    // djb:workaround-redirect from landing page (home to shop)
    // djb:todo-should handle route in ng, but seems to break other nav/route logic
    if (window.location.href.toLowerCase().includes("/home/")) {
        let url = window.location.href;

        const customerId = sessionStorage.getItem("customerID");
        const customerGroupId = sessionStorage.getItem("customerGroupID");
        if (customerGroupId === "N-082" || customerId === 'N-082') {// && customerId != "N-954267" || customerId == 'N-9171E') {
            url = url.replace("package-builder", "wheel-search");
        }

        url = url.replace("/home/", "/shop/");
        url = url.replace("/Home/", "/shop/");
        window.location.href = url;
        return;
    }

    this.currentWheelSizeSelected = '';

    //this.packageBuilderService.reset();
    this.wheelType = Constants.PRODUCT_TYPE_WHEEL;
    this.tireType = Constants.PRODUCT_TYPE_TIRE;
    this.labourType = Constants.PRODUCT_TYPE_LABOUR;
    this.hardwareType = Constants.PRODUCT_TYPE_HARDWARE;
    this.packagekitType = Constants.PRODUCT_TYPE_PACKAGEKIT;

    this.wheelsRoute = PackageBuilderConstants.WHEELS_ROUTE;
    this.tiresRoute = PackageBuilderConstants.TIRES_ROUTE;
    this.hardwaresRoute = PackageBuilderConstants.HARDWARES_ROUTE;
    this.summaryRoute = PackageBuilderConstants.SUMMARY_ROUTE;
    this.packagekitsRoute = PackageBuilderConstants.PACKAGEKITS_ROUTE;
    
    this.subs.push(this.packageBuilderService.onReadyChange.subscribe(ready => {
      //Helper.log(`pb.pbs.onReadyChange: ${ready}`);
      this.isReady = ready;
      if (document.getElementById('#pageAnchor') != null)
        document.getElementById('#pageAnchor').scrollIntoView();
    }, Helper.handleError)
    );

    this.subs.push(this.route.queryParamMap.subscribe(params => {
      this.log(`route.queryParam extract mym and stagger from params`);
      const mym = Helper.extractMakeYearModelFromRouteParam(params);
      this.currentWheelStagger = Helper.extractWheelStaggerFromRouteParam(params);
      this.currentTireStagger = Helper.extractTireStaggerFromRouteParam(params);
      this.defaultWheelStagger = Helper.extractWheelDefaultStaggerFromRouteParam(params);
      this.defaultTireStagger = Helper.extractTireDefaultStaggerFromRouteParam(params);
      const tirefst = Helper.isProductTypePreferenceTire();
      if (!this.currentMyM) {
        this.currentMyM = mym;
      }
      if (this.packageBuilderService.makeYearModelChanged(mym) || this.packageBuilderService.productTypePreferenceChanged()) {
        sessionStorage.setItem("ExtensionCap", "no");
        sessionStorage.setItem("ExtensionCapRemovedByUser", "no");

        if (mym != null && mym.make != null) {
          let searchFrom = 'packageBuilder';
          const url = decodeURIComponent(this.router.url);
          if (url.includes('search-by-vehicle')) {
            if (url.includes('package-builder'))
              searchFrom = 'packageBuilder';
            else if (url.includes('wheel-search'))
              searchFrom = 'wheels';
            else if (url.includes('tire-search'))
              searchFrom = 'tires';
          }
          this.packageBuilderService.sendMakeYearModel(mym, searchFrom);
        }

        this.currentMyM = mym;
        this.tiresFirst = tirefst;
        this.packageBuilderService.setProductTypePreference(tirefst);
        this.packageBuilderService.setMakeYearModel(mym, this.currentWheelStagger, this.currentTireStagger);
        this.searchResult = `${mym.make} ${mym.year} ${mym.model}`;
        this.packageBuilderService.clear();
        this.cards = new Array<GenericSummaryCardDtoResponse>();
        this.separatedProducts = new Array<HardwareCategoryCards>();
        this.packageBuilderService.logSearch();
      }
      else if (this.packageBuilderService.wheelStaggerChanged(this.currentWheelStagger)
        //|| (this.packageBuilderService.tireStaggerInitialChanged(this.currentTireStagger))
      ) {
        this.packageBuilderService.setWheelStagger(this.currentWheelStagger);
        if (!tirefst) {
          if (this.currentWheelStagger === this.defaultWheelStagger) {
            this.currentTireStagger = this.defaultTireStagger;
          }
          else if (this.currentWheelStagger === 'D' || this.currentWheelStagger === 'W') {
            this.currentTireStagger = Constants.STAGGER_WIDTH;
          }
          else {
            this.currentTireStagger = '';
          }
          if (this.packageBuilderService.tireStaggerChanged(this.currentTireStagger))
            this.packageBuilderService.setTireStagger(this.currentTireStagger);
        }
       
        const model = this.packageBuilderService.getPackageBuilderModel();
        if (model != null && model.front != null && model.front.wheel != null) {
          if (tirefst)
            this.packageBuilderService.deselectWheels();
          else
            this.packageBuilderService.clear(false);
        }
        
        if (tirefst && this.packageBuilderService.tireStaggerChanged(this.currentTireStagger)) {
          this.packageBuilderService.setTireStagger(this.currentTireStagger);
          if (model != null && model.front != null && model.front.tire != null)
            this.packageBuilderService.clear(false);
        }
        
      }
      else if (this.packageBuilderService.tireStaggerChanged(this.currentTireStagger)) {
        this.packageBuilderService.setTireStagger(this.currentTireStagger);
        if (tirefst) {
          if (this.currentTireStagger === this.defaultTireStagger) {
            this.currentWheelStagger = this.defaultWheelStagger;
          }
          else if (this.currentTireStagger === 'D' || this.currentTireStagger === 'W') {
            this.currentWheelStagger = Constants.STAGGER_WIDTH;
          }
          else if (this.currentWheelStagger !== Constants.STAGGER_OFFSET) {
            this.currentWheelStagger = '';
          }
          if (this.packageBuilderService.wheelStaggerChanged(this.currentWheelStagger))
            this.packageBuilderService.setWheelStagger(this.currentWheelStagger);
        }
        const model = this.packageBuilderService.getPackageBuilderModel();
        if (model != null && model.front != null && model.front.tire != null) {
          if (tirefst)
            this.packageBuilderService.clear(false);
          else
            this.packageBuilderService.deselectTires();
        }
      }
    }, Helper.handleError));

    this.subs.push(this.packageBuilderService.onPackageChange.subscribe(pbModel => {
      this.log(`onPackageChange`);
      const tirefst = Helper.isProductTypePreferenceTire();
      if (!tirefst) {
        this.wheelLinkDisabled = false;
        if (pbModel.front.wheel) {
          this.tireLinkDisabled = false;
          this.hardwareLinkDisabled = false;
          if (pbModel.front.tire)
            this.studdingLinkDisabled = false;
          else
            this.studdingLinkDisabled = true;
          this.summaryLinkDisabled = false;
        } else {
          this.tireLinkDisabled = true;
          this.hardwareLinkDisabled = true;
          this.studdingLinkDisabled = true;
          this.summaryLinkDisabled = true;
        }
      }
      else {
        this.tireLinkDisabled = false;
        if (pbModel.front.tire) {
          this.wheelLinkDisabled = false;
          if (pbModel.front.wheel)
            this.hardwareLinkDisabled = false;
          else
            this.hardwareLinkDisabled = true;
          this.studdingLinkDisabled = false;
          this.summaryLinkDisabled = false;
        } else {
          this.wheelLinkDisabled = true;
          this.hardwareLinkDisabled = true;
          this.studdingLinkDisabled = true;
          this.summaryLinkDisabled = true;
        }
      }
    }, Helper.handleError));

    this.subs.push(this.packageBuilderService.onFilterChange.subscribe(_response => {
      const filterSource = _response['filterSource'];
      const filterAction = _response['filterAction'];
      const addedFilters = _response['addedFilters'];

      if (filterAction === 'clearAll') {
        this.appliedFilters.wheelFilters = {};
        this.appliedFilters.tireFilters = {};
      } else {
        switch (filterSource) {
          case 'wheels':
            if (filterAction === 'clearFilter')
              this.appliedFilters.wheelFilters = {};
            else
              this.appliedFilters.wheelFilters = addedFilters['wheelFilters'];
            break;
          case 'tires':
            if (filterAction === 'clearFilter')
              this.appliedFilters.tireFilters = {};
            else
              this.appliedFilters.tireFilters = addedFilters['tireFilters'];
            break
        }
      }
    }));

    this.subs.push(this.packageBuilderService.onSummaryChange.subscribe(model => {
      this.log('onSummaryChange');

      if (model['wheelChanged']) {
        const selectedWheelSize = model.front.wheel ? model.front.wheel['wheelSize'] : 'no-sel'

        this.log('Current wheel: ' + this.currentWheelSizeSelected);
        this.log('Selected wheel: ' + selectedWheelSize);

        if (this.currentWheelSizeSelected !== selectedWheelSize && Object.keys(this.appliedFilters.tireFilters).length > 0) {
          this.log('Reset tire filters');
          this.appliedFilters.tireFilters = {};
          this.appliedFilters.tireFilters['reset'] = 1;
        } else if (this.appliedFilters.tireFilters['reset'])
          delete this.appliedFilters.tireFilters['reset'];

        this.currentWheelSizeSelected = model.front.wheel['wheelSize'];
      }

      this.frontSelections.selectedLabours = model.front.labours || [];
      this.frontSelections.selectedHardwares = model.front.hardwares || [];
      this.rearSelections.selectedLabours = model.rear.labours || [];
      this.rearSelections.selectedHardwares = model.rear.hardwares || [];
	  // FRONT WHEEL
      this.frontSelections.selectedWheel = model.front.wheel;
      this.frontSelectionsOnSaleAtDealerCost.selectedWheel = null;
      if (model.front.wheel && model.front.wheel.isOnSpecial) {
        const frontProducts = this.getOnSaleProducts(model.front.wheel);
        this.frontSelections.selectedWheel = frontProducts.onSaleProduct;
        this.frontSelectionsOnSaleAtDealerCost.selectedWheel = frontProducts.onSaleProductAtDealerCost;
      }
	  // REAR WHEEL
      this.rearSelections.selectedWheel = model.rear.wheel;
      this.rearSelectionsOnSaleAtDealerCost.selectedWheel = null;
      if (model.rear.wheel && model.rear.wheel.isOnSpecial) {
        const rearProducts = this.getOnSaleProducts(model.rear.wheel);
        this.rearSelections.selectedWheel = rearProducts.onSaleProduct;
        this.rearSelectionsOnSaleAtDealerCost.selectedWheel = rearProducts.onSaleProductAtDealerCost;
      }
	  
      // FRONT TIRE
      this.frontSelections.selectedTire = model.front.tire;
      this.frontSelectionsOnSaleAtDealerCost.selectedTire = null;
      if (model.front.tire && model.front.tire.isOnSpecial) {
        const frontProducts = this.getOnSaleProducts(model.front.tire);
        this.frontSelections.selectedTire = frontProducts.onSaleProduct;
        this.frontSelectionsOnSaleAtDealerCost.selectedTire = frontProducts.onSaleProductAtDealerCost;
      }
      // REAR TIRE
      this.rearSelections.selectedTire = model.rear.tire;
      this.rearSelectionsOnSaleAtDealerCost.selectedTire = null;
      if (model.rear.tire && model.rear.tire.isOnSpecial) {
        const rearProducts = this.getOnSaleProducts(model.rear.tire);
        this.rearSelections.selectedTire = rearProducts.onSaleProduct;
        this.rearSelectionsOnSaleAtDealerCost.selectedTire = rearProducts.onSaleProductAtDealerCost;
      }
      //this.updateNavigation();
    }, Helper.handleError));

    // jl: nested subscription extracted from this.packageBuilderService.onFlowChange, does not appear to used anywhere
    //this.subs.push(this.route.data.subscribe(data => {
    //  //this.route.data.subscribe(data => {
    //  this.context = data.context;
    //}, Helper.handleError));

    this.log(`OnFlowChange pbs id: ${this.packageBuilderService.id}`);
    this.subs.push(this.packageBuilderService.onFlowChange.subscribe(
      nextFlow => {
        this.log(`pbs.OnFlowChange: nextFlow ${nextFlow} pbs${this.packageBuilderService.id}`);
        let mymQueryParams = Helper.getMakeYearModelQueryParams(this.currentMyM);

        if (this.currentWheelStagger !== null)
          mymQueryParams[Constants.WHEEL_STAGGER_ROUTE_PARAM] = this.currentWheelStagger;
        else
          mymQueryParams[Constants.WHEEL_STAGGER_ROUTE_PARAM] = this.defaultWheelStagger;
        if (this.currentTireStagger !== null)
          mymQueryParams[Constants.TIRE_STAGGER_ROUTE_PARAM] = this.currentTireStagger;
        else
          mymQueryParams[Constants.TIRE_STAGGER_ROUTE_PARAM] = this.defaultTireStagger;

        if (nextFlow === PackageBuilderFlow.WHEELS) {
          if (this.currentMyM.defaultAggressive)
            mymQueryParams["show"] = "Aggressive";
          //if (this.currentWheelStagger !== null)
          //  mymQueryParams[Constants.WHEEL_STAGGER_ROUTE_PARAM] = this.currentWheelStagger;
          //else
          //  mymQueryParams[Constants.WHEEL_STAGGER_ROUTE_PARAM] = this.defaultWheelStagger;
          //if (this.currentTireStagger !== null)
          //  mymQueryParams[Constants.TIRE_STAGGER_ROUTE_PARAM] = this.currentTireStagger;
          //else
          //  mymQueryParams[Constants.TIRE_STAGGER_ROUTE_PARAM] = this.defaultTireStagger;
        }
        else if (nextFlow === PackageBuilderFlow.TIRES) {
          //mymQueryParams[Constants.WHEEL_STAGGER_ROUTE_PARAM] = this.currentWheelStagger;
          //mymQueryParams[Constants.TIRE_STAGGER_ROUTE_PARAM] = this.currentTireStagger;
          if (this.packageBuilderService.oeTireSizeFitsAggressive ||
            this.currentMyM.defaultAggressive ||
            this.packageBuilderService.wheelIsAggressive) {
            mymQueryParams["show"] = "Aggressive";
          }
        }
        else {
          //mymQueryParams[Constants.WHEEL_STAGGER_ROUTE_PARAM] = this.currentWheelStagger;
          //mymQueryParams[Constants.TIRE_STAGGER_ROUTE_PARAM] = this.currentTireStagger;
        }
        if (this.defaultWheelStagger !== null && this.defaultTireStagger !== null) {
          mymQueryParams[Constants.DEFAULT_STAGGER_ROUTE_PARAM] = this.defaultWheelStagger + this.defaultTireStagger;
        }
        switch (nextFlow) {
          case PackageBuilderFlow.NONE:
            if (!this.tiresFirst) {
              this.log('router.navigate flow(NONE):' + this.wheelsRoute);
              this.navigate([this.wheelsRoute], { queryParams: mymQueryParams, queryParamsHandling: 'merge', relativeTo: this.route });
            }
            else {
              this.log('router.navigate flow(NONE):' + this.tiresRoute);
              this.navigate([this.tiresRoute], { queryParams: mymQueryParams, queryParamsHandling: 'merge', relativeTo: this.route });
            }
            this.pbFlow = 0;
            break;
          case PackageBuilderFlow.WHEELS:
            if (Object.keys(this.appliedFilters).length > 0) {
              Object.keys(this.appliedFilters.wheelFilters).forEach(property => {
                mymQueryParams[property] = this.appliedFilters.wheelFilters[property];
              });
            }
            this.url = decodeURIComponent(this.router.url);
            if (this.url.includes("quotequote")) {
              this.quoteQuote();
              this.navigate([this.summaryRoute], { queryParams: mymQueryParams, relativeTo: this.route });
              this.pbFlow = 4;
              break;
            } else {
              this.packageBuilderService.setIsReady(false);
              this.pbFlow = 1;
              this.log('router.navigate flow(WHEELS):' + this.wheelsRoute);
              this.AddPagingParams("Wheels", mymQueryParams);
              this.navigate([this.wheelsRoute], { queryParams: mymQueryParams, queryParamsHandling: '', relativeTo: this.route });
              break;
            }
          case PackageBuilderFlow.TIRES:
            if (Object.keys(this.appliedFilters).length > 0) {
              Object.keys(this.appliedFilters.tireFilters).forEach(property => {
                mymQueryParams[property] = this.appliedFilters.tireFilters[property];
              });
            }
            this.packageBuilderService.setIsReady(false);
            this.pbFlow = 2;
            this.log('router.navigate flow(TIRES):' + this.tiresRoute);
            this.AddPagingParams("Tires", mymQueryParams);
            this.navigate([this.tiresRoute], { queryParams: mymQueryParams, queryParamsHandling: '', relativeTo: this.route });
            break;
          case PackageBuilderFlow.HARDWARE:
            this.separatedProducts = new Array<HardwareCategoryCards>();
            this.log('router.navigate flow (HARDWARE):' + this.hardwaresRoute);
            this.navigate([this.hardwaresRoute], { queryParams: mymQueryParams, relativeTo: this.route });
            this.pbFlow = 3;
            //this.subs.push(this.route.data.subscribe(data => {
            //  //this.route.data.subscribe(data => {
            //  this.context = data.context;
            //}, Helper.handleError));
            //let empty = true;
            //this.subs.push(this.hardwareService.onProducts.pipe(take(1)).subscribe(products => {
            this.subs.push(this.hardwareService.onProducts.subscribe(products => {
              if (!this.packageBuilderService.loadedFromSession) {
                this.packageBuilderService.serviceSummaryCards.forEach(sc => {
                  if (!products.productSummaryCards.some(c => c.frontProduct.longSKU === sc.frontProduct.longSKU))
                    products.productSummaryCards.push(sc);
                });
                this.cards = products.productSummaryCards;
              }
              this.log(`hs.onProducts: flow(${nextFlow}) cards(${this.cards.length} productChanged: ${this.productChanged})`);
              this.updateNavigation("hs.onProducts");
              if (this.productChanged) {
                this.flowToNextTab();
                this.productChanged = false;
              }
            }, Helper.handleError))
            //}, Helper.handleError));
            this.updateFilterDisplay(AccessoryCategory.Adapters);
            break;
          case PackageBuilderFlow.PACKAGE_BUILDER_SUMMARY:
            const _wheelIsDirectFit = this.packageBuilderService.wheelIsDirectFit;
            const _pbHasNutsBolts = this.packageBuilderService.getPackageBuilderModel().front.hardwares.some(h => h.category === AccessoryCategory.Nuts || h.category === AccessoryCategory.Bolts);
            const lugsDifferentFromOENotChosen = this.cards.some(card => card.frontProduct.details.details.some(detail => detail.accessoryType === AccessoryCategory.Nuts || detail.accessoryType === AccessoryCategory.Bolts));

            if (lugsDifferentFromOENotChosen && !_wheelIsDirectFit && !_pbHasNutsBolts) {
              const note = this.packageBuilderService.getTranslatedNote('FC.ProductWarningsNotes.LugsDifferentFromOENotChosen');
              const model = this.packageBuilderService.getPackageBuilderModel();

              if (model.front.wheel !== null && (model.front.wheel.warningNotes == null || !model.front.wheel.warningNotes.some(n => n === note)))
                this.packageBuilderService.addNoteToWheel(note, Positions.FRONT);

              if (model.rear !== null && model.rear.wheel != null && (model.rear.wheel.warningNotes == null || !model.rear.wheel.warningNotes.some(n => n === note))) {
                this.packageBuilderService.addNoteToWheel(note, Positions.REAR);
              }
            }

            const hubRingsHardware = this.cards.some(card => card.frontProduct.details.details.some(detail => detail.accessoryType === AccessoryCategory.HubRings));
            if (hubRingsHardware) {
              const pbBuilderModel = this.packageBuilderService.getPackageBuilderModel();
              let pbHasHubRingsSelected = pbBuilderModel.front.hardwares.some(h => h.category === AccessoryCategory.HubRings);

              if (pbBuilderModel.rear !== null && pbBuilderModel.rear.hardwares !== null)
                pbHasHubRingsSelected = pbHasHubRingsSelected || pbBuilderModel.rear.hardwares.some(h => h.category === AccessoryCategory.HubRings);

              if (!pbHasHubRingsSelected && !_wheelIsDirectFit) {
                const note = this.packageBuilderService.getTranslatedNote('FC.ProductWarningsNotes.HubRingsNotChosen');
                const model = this.packageBuilderService.getPackageBuilderModel();

                if (model.front.wheel !== null && (model.front.wheel.warningNotes == null || !model.front.wheel.warningNotes.some(n => n === note)))
                  this.packageBuilderService.addNoteToWheel(note, Positions.FRONT);

                if (model.rear !== null && model.rear.wheel != null && (model.rear.wheel.warningNotes == null || !model.rear.wheel.warningNotes.some(n => n === note))) {
                  this.packageBuilderService.addNoteToWheel(note, Positions.REAR);
                }
              }
            }
            this.packageBuilderService.removeOETireNote();

            this.log(`router.navigate flow(SUMMARY): ${this.summaryRoute} `);
            this.navigate([this.summaryRoute], { queryParams: mymQueryParams, relativeTo: this.route });
            this.pbFlow = 4;
            break;
          case PackageBuilderFlow.PACKAGEKITS:
            this.packageBuilderService.setIsReady(false);
            this.pbFlow = 5;
            this.log('router.navigate flow(PACKAGEKITS):' + this.packagekitsRoute);
            this.AddPagingParams("PackageKits", mymQueryParams);
            this.navigate([this.packagekitsRoute], { queryParams: mymQueryParams, queryParamsHandling: '', relativeTo: this.route });
            break;
        }
      }, Helper.handleError));

    //awm: cp
    // event put in place so we can adjust the navigation after oem data is loaded
    // specifically used to determine if tpms, nuts or bolts are to be displayed
    this.subs.push(this.packageBuilderService.onOEMChange.subscribe(
      oemData => {
        this.log('onOEMChange');
        this.oemData = oemData;
        this.showNavTabs();
      }, Helper.handleError));

    //awm:cp added to clear the cards and reevaluate the navigation so the correct tabs display.
    this.subs.push(this.packageBuilderService.onWheelRemoved.subscribe(
      blah => {
        this.log('onWheelRemoved: cleared cards, separated products, and service items');
        if (!this.tiresFirst) {
          this.cards = new Array<GenericSummaryCardDtoResponse>();
          this.packageBuilderService.clearServiceCards();
        }
        else {
          let testCards = this.cards.filter(c => c.frontProduct.details.details.some(d => d.accessoryType === AccessoryCategory.Studding));
          this.cards = testCards;
        }
        this.separatedProducts = new Array<HardwareCategoryCards>();
        this.hardwareService.clearProducts();
        this.updateNavigation("onWheelRemoved");
        //location.reload();
      }, Helper.handleError)
    );

    this.subs.push(this.packageBuilderService.onTireRemoved.subscribe(
      blah => {
        this.log(`onTireRemoved: cards(${this.cards.length}) clear service cards`);
        this.packageBuilderService.clearServiceCards();
        if (this.tiresFirst)
          this.cards = new Array<GenericSummaryCardDtoResponse>();
        else {
          // djb:todo-remove service items
          let testCards = this.cards.filter(c => c.frontProduct.details.details.some(d => d.accessoryType !== AccessoryCategory.Mounting)
            && c.frontProduct.details.details.some(d => d.accessoryType !== AccessoryCategory.Studding));
          if (testCards != null)
            testCards.forEach(card => {
              if (card.frontProduct.details.details.find(d => d.label === 'Type').accessoryType == AccessoryCategory.TPMS && card.wmbRequired)
                card.visible = false;
            });
          this.cards = testCards;
        }
        this.updateNavigation("pbs.onTireRemoved");
      }, Helper.handleError)
    );

    this.subs.push(this.packageBuilderService.onClearForNewSearch.subscribe(
      blah => {
        this.log('onClearForNewSearch: cards and separated products cleared');
        this.hardwareService.clearProducts();
        this.cards = new Array<GenericSummaryCardDtoResponse>();
        this.separatedProducts = new Array<HardwareCategoryCards>();
        this.updateNavigation("onClearForNewSearch");
      }, Helper.handleError)
    );

    this.subs.push(this.packageBuilderService.onAddProductCard.subscribe(
      card => {
        this.log(`onAddProductCard: ${card.description} `);
        this.packageBuilderService.serviceSummaryCards.forEach(sc => {
          if (!this.cards.some(c => c.frontProduct.longSKU === sc.frontProduct.longSKU))
            this.cards.push(sc);
        });
        //this.buildSeparatedProducts();
        //this.showNavTabs();
        this.updateNavigation("onAddProductCard");
        if (this.tiresFirst && this.getHardwareAccessoryType(card) === AccessoryCategory.Studding)
          this.flowToNextTab();
      }, Helper.handleError)
    );

    this.subs.push(this.packageBuilderService.onProductAdded.subscribe(model => {
      this.log('onProductAdded');
      if (!this.tiresFirst || model.type !== Constants.PRODUCT_TYPE_TIRE)
        this.productChanged = true;
    }, Helper.handleError)
    );

    this.subs.push(this.packageBuilderService.onUpdateNavigation.subscribe(
      model => {
        this.updateNavigation("onUpdateNavigation");
      }, Helper.handleError)
    );

    this.LoadFromSessionOni18nSwitch();
  }

  getOnSaleProducts(pbsp: PackageBuilderSummaryProduct): any {
    let result = {
      onSaleProduct: this.copyPackageBuilderSummaryProduct(pbsp),
      onSaleProductAtDealerCost: null
    };

    if (pbsp.qty > pbsp.isOnSpecialMaxQty) {
      const onSaleProductAtDealerCostQty = pbsp.qty - pbsp.isOnSpecialMaxQty;
      let onSaleProductAtDealerCost = this.copyPackageBuilderSummaryProduct(pbsp);
      onSaleProductAtDealerCost.qty = onSaleProductAtDealerCostQty;
      onSaleProductAtDealerCost.totalPrice = onSaleProductAtDealerCostQty * pbsp.dealerCost;
      onSaleProductAtDealerCost.isOnSpecialAtDealerCost = true;

      if (pbsp.isOnSpecialMaxQty > 0) {
        result.onSaleProduct.qty = pbsp.isOnSpecialMaxQty;
        result.onSaleProduct.totalPrice = pbsp.isOnSpecialMaxQty * pbsp.customerPrice;

        result.onSaleProductAtDealerCost = onSaleProductAtDealerCost;
      } else
        result.onSaleProduct = onSaleProductAtDealerCost
    }

    return result;
  }

  copyPackageBuilderSummaryProduct(pbsp: PackageBuilderSummaryProduct) {
    const hardCopy = Object.assign(new PackageBuilderSummaryProduct(), pbsp);
    return hardCopy;
  }

  ngOnDestroy() {
    this.log('onDestroy');
    this.subs.forEach(sub => sub.unsubscribe());
    // djb:remove the listener too
    this.listenFunc();
  }

  private LoadFromSessionOni18nSwitch(): void {
    //if (sessionStorage.getItem('pbProducts') != null &&
    //  sessionStorage.getItem('pbFlow') != null &&
    //  sessionStorage.getItem('pbOEMData') != null &&
    //  sessionStorage.getItem('frontSummaries') != null &&
    //  sessionStorage.getItem('rearSummaries') != null) {
    //  this.log(`populate package from session id:${this.packageBuilderService.id}`);
    //  const pbModel: StaggeredPackageBuilderModel = JSON.parse(sessionStorage.getItem('pbProducts'));
    //  const pbFlow: PackageBuilderFlow = JSON.parse(sessionStorage.getItem('pbFlow'));
    //  const pbOEMData: VehicleOemDataDtoResponse = JSON.parse(sessionStorage.getItem('pbOEMData'));
    //  this.frontSelections = JSON.parse(sessionStorage.getItem('frontSummaries'));
    //  this.rearSelections = JSON.parse(sessionStorage.getItem('rearSummaries'));
    //  this.cards = JSON.parse(sessionStorage.getItem('pbCards'));
    //  sessionStorage.removeItem('pbProducts');
    //  sessionStorage.removeItem('pbFlow');
    //  sessionStorage.removeItem('pbOEMData');
    //  sessionStorage.removeItem('frontSummaries');
    //  sessionStorage.removeItem('rearSummaries');
    //  sessionStorage.removeItem('pcCards');
    //  this.pbFlow = pbFlow;
    //  this.packageBuilderService.populatePackage(pbModel, pbFlow, this.frontSelections, this.rearSelections, pbOEMData);
    //  this.updateNavigation("LoadFromSessionFori18nChange");

    //  if (Helper.activeTab == 'whe' || Helper.activeTab === 'tir' || Helper.activeTab === 'sum') {
    //    Helper.setActiveTabState(Helper.activeTab);
    //  } else {
    //    this.packageBuilderService.navigateToHardwares();
    //    //this.packageBuilderService.changeTab('i18n', +Helper.activeTab);
    //    //Helper.setActiveTabState(Helper.activeTab);
    //  }
    //  this.packageBuilderService.loadedFromSession = true;
    //}
  }


  private updateNavigation(msg: string) {
    this.log(`updateNavigation: ${msg} `);
    this.buildSeparatedProducts();
    // djb:hack-to remove service items before nav
    //if (this.packageBuilderService.serviceSummaryCards.length === 0) {
    //  let removeServiceItems = this.separatedProducts.filter(sp => sp.categoryName !== 'Mounting');
    //  this.separatedProducts = removeServiceItems.filter(sp => sp.categoryName !== 'Studding');
    //}
    this.showNavTabs();
  }

  // djb-note:required by navigation when adding/deleting cards
  // djb:note-buildSeparated products is included in updateNavigation
  buildSeparatedProducts() {
    // djb:hack-determine why we're not ready yet
    if (typeof this.cards === "undefined") {
      this.log(`buildSeparatedProducts: BYPASSED`);
      return;
    }
    this.separatedProducts = new Array<HardwareCategoryCards>();
    this.cards.forEach(product => {
      const category = this.getHardwareCategory(product);
      product.visible = true;
      if (this.getHardwareAccessoryType(product) === AccessoryCategory.Keys)
        product.visible = false;
      else if (this.getHardwareAccessoryType(product) === AccessoryCategory.TPMS && product.wmbRequired)
        product.visible = false;
      if (this.separatedProducts.some(c => c.categoryName === category)) {
        this.separatedProducts.find(c => c.categoryName === category).cards.push(product);
      } else {
        const newCategory = new HardwareCategoryCards();
        this.visibility[category] = false;
        newCategory.categoryName = category;
        newCategory.catId = this.getHardwareAccessoryType(product);
        newCategory.isActiveTab = false;
        newCategory.hasSelectedCard = false;
        if (this.getHardwareAccessoryType(product) === AccessoryCategory.Keys) {
          if (this.separatedProducts.some(c => c.cards.some(card => card.frontProduct.details.details
            .some(detail => detail.accessoryType === AccessoryCategory.Bolts)))) {
            newCategory.noteLabel = "FC.HardwaresGrid.KeysNote.Bolt";
          } else if (this.separatedProducts.some(c => c.cards.some(card => card.frontProduct.details.details
            .some(detail => detail.accessoryType === AccessoryCategory.Nuts)))) {
            newCategory.noteLabel = "FC.HardwaresGrid.KeysNote.Nut";
          }
          newCategory.showNote = true;
        } else {
          newCategory.showNote = false;
        }
        newCategory.cards = [product];
        this.separatedProducts.push(newCategory);
      }
    });
    this.log(`buildSeparatedProducts: categories(${this.separatedProducts.length}) cards(${this.cards.length})`);
  }

  updateHardware(id: string, quantity: number, shortSKU: string, imageURL: string, title: string, price: string, pairNo: string, category: AccessoryCategory, position: string) {
    const product = new Product({
      id: id,
      quantity: quantity,
      warningNotes: null,
      type: Constants.PRODUCT_TYPE_HARDWARE,
      category: category,
      pairNo: pairNo,
      position: position
    });

    const positionContainer = "B" === PositionValues.REAR ? Positions.REAR : Positions.FRONT;
    product.quantity = quantity;
    if (this.packageBuilderService) {
      this.packageBuilderService.updateHardware(product, this.hardwareSummary(id, quantity, shortSKU, imageURL, title, price, pairNo, category, position), positionContainer);
    }
  }

  hardwareSummary(longSKU: string, qty: number, shortSKU: string, imageURL: string,
    title: string, price: string, pairNo: string, category: AccessoryCategory, position: string): PackageBuilderSummaryProduct {
    const summaryProduct = new PackageBuilderSummaryProduct();
    summaryProduct.imgURL = imageURL;
    summaryProduct.description = title;
    summaryProduct.shortSKU = shortSKU;
    summaryProduct.longSKU = longSKU;
    summaryProduct.qty = qty;
    summaryProduct.customerPrice = parseFloat(price);
    summaryProduct.totalPrice = parseFloat(price) * qty;
    summaryProduct.accessoryType = category;
    summaryProduct.pairNo = pairNo;
    summaryProduct.position = position;
    return summaryProduct;
  }

  summaryFromCard(longSKU: string, shortSKU: string, imageUrl: string, customerPrice: string, qty: number,
    type: string, title: string, details: string, warnings: string[], pairNo: string, position: string): PackageBuilderSummaryProduct {
    const summaryProduct = new PackageBuilderSummaryProduct();
    summaryProduct.imgURL = imageUrl;
    summaryProduct.description = title + '\n' + details;
    summaryProduct.shortSKU = shortSKU;
    summaryProduct.longSKU = longSKU;
    summaryProduct.qty = qty;
    summaryProduct.customerPrice = Number(customerPrice);
    summaryProduct.totalPrice = summaryProduct.customerPrice * summaryProduct.qty;
    summaryProduct.warningNotes = warnings;
    summaryProduct.pairNo = pairNo;
    summaryProduct.position = position;
    return summaryProduct;
  }

  createProduct(id: string, qty: number, warningNotes: string[], type: string, pairNo: string, category?: AccessoryCategory, position?: string): Product {
    return new Product({
      id: id,
      warningNotes: warningNotes,
      quantity: qty,
      type: type,
      pairNo: pairNo,
      category: category,
      position: position
    });
  }

  postToCart() {
    this.packageBuilderService.postPackageToCart();
  }

  updateFilterDisplay(catId: AccessoryCategory) {
  }

  goToKits() {
    document.getElementById('pbWrapper').scrollIntoView(true);
    document.getElementById('howToMeasure').style.display = "none";

    this.packageBuilderService.navigateToKits();
  }

  goToWheels() {
    document.getElementById('pbWrapper').scrollIntoView(true);
    document.getElementById('howToMeasure').style.display = "none";

    this.packageBuilderService.navigateToWheels();
  }

  goToTires() {
    document.getElementById('pbWrapper').scrollIntoView(true);
    document.getElementById('howToMeasure').style.display = "none";
    this.packageBuilderService.navigateToTires();
  }

  goToSummary() {
    document.getElementById('pbWrapper').scrollIntoView(true);
    document.getElementById('howToMeasure').style.display = "none";
    this.packageBuilderService.navigateToSummary();
  }

  // djb:dry/refactor-replace package-builder.html with goToHardware('FC.PackageBuilder.HubCaps');
  goToHardware(i18n: string, catId: AccessoryCategory) {
    let isOEMWheel: boolean = false;
    if (this.frontSelections.selectedWheel)
      isOEMWheel = this.frontSelections.selectedWheel.longSKU.toUpperCase().includes('OEMSIZE');
    document.getElementById('howToMeasure').style.display = catId === AccessoryCategory.Bolts && isOEMWheel ? "block" : "none";

    document.getElementById('pbWrapper').scrollIntoView(true);
    const tabName = this.translate.instant(i18n);
    this.packageBuilderService.changeTab(tabName, catId);
    this.packageBuilderService.navigateToHardwares();
  }

  goToHub() {
    this.goToHardware('FC.PackageBuilder.HubCaps', AccessoryCategory.HubCaps);
  }

  goToCaps() {
    this.goToHardware('FC.PackageBuilder.Caps', AccessoryCategory.CenterCaps);
  }

  goToInserts() {
    this.goToHardware('FC.PackageBuilder.Inserts', AccessoryCategory.Inserts);
  }

  goToRivets() {
    this.goToHardware('FC.PackageBuilder.Rivets', AccessoryCategory.Rivets);
  }

  goToStudding() {
    this.goToHardware('FC.PackageBuilder.Studding', AccessoryCategory.Studding);
  }

  goToMounting() {
    this.goToHardware('FC.PackageBuilder.Installation', AccessoryCategory.Mounting);
  }

  goToRings() {
    this.goToHardware('FC.PackageBuilder.Rings', AccessoryCategory.HubRings);
  }

  goToKeys() {
    this.goToHardware('FC.PackageBuilder.Keys', AccessoryCategory.Keys);
  }

  goToLockBolts() {
    //		this.goToHardware('FC.PackageBuilder.Locks', AccessoryCategory.WheelLocks);
    this.goToHardware('FC.PackageBuilder.Locks', AccessoryCategory.LockBolts);
  }

  goToLockNuts() {
    this.goToHardware('FC.PackageBuilder.Locks', AccessoryCategory.LockNuts);
  }

  goToTPMS() {
    this.goToHardware('FC.PackageBuilder.TPMS', AccessoryCategory.TPMS);
  }

  goToValves() {
    this.goToHardware('FC.PackageBuilder.OptionalValves', AccessoryCategory.OptionalValves);
  }

  goToTireValves() {
    this.goToHardware('FC.PackageBuilder.Valves', AccessoryCategory.TireValves);
  }

  goToBolts() {
    this.goToHardware('FC.PackageBuilder.Bolts', AccessoryCategory.Bolts);
  }

  goToNuts(explicit: string) {
    this.goToHardware('FC.PackageBuilder.Nuts', AccessoryCategory.Nuts);
  }

  getHardwareCategory(card: GenericSummaryCardDtoResponse): string {
    return card.frontProduct.details.details.find(d => d.label === 'Type').value;
  }

  getHardwareAccessoryType(card: GenericSummaryCardDtoResponse): number {
    return card.frontProduct.details.details.find(d => d.label === 'Type').accessoryType;
  }

  goToDialynKits() {
    this.goToHardware('FC.PackageBuilder.InstallationKits', AccessoryCategory.InstallationKit);
  }

  visible = function (cat: string) {
    return this.visibility[cat];
  };

  toggle = function (cat: string) {
    this.visibility[cat] = !this.visibility[cat];
  };

  onCardChanged(eventArgs: CardChangedEventArgs) {
    this.flowToNextTab();
    // save which card was selected/deselected
    if (this.separatedProducts.some(c => c.categoryName === eventArgs.category) &&
      this.separatedProducts.find(c => c.categoryName === eventArgs.category).cards
        .some(card => card.frontProduct.longSKU === eventArgs.longSKU)) {
      const category = this.separatedProducts.find(c => c.categoryName === eventArgs.category);
      category.hasSelectedCard = eventArgs.selected;
      category.cards.find(card => card.frontProduct.longSKU === eventArgs.longSKU).selected = eventArgs.selected;
    }
    // additional logic for bolts/nuts
    if (eventArgs.accessoryType === AccessoryCategory.Bolts ||
      eventArgs.accessoryType === AccessoryCategory.Nuts) {
      // set visibility of keys
      if (eventArgs.selected) {
        if (this.separatedProducts.some(c => c.categoryName === eventArgs.category) &&
          this.separatedProducts.find(c => c.categoryName === eventArgs.category).cards
            .some(card => card.frontProduct.longSKU === eventArgs.longSKU) &&
          this.separatedProducts.find(c => c.categoryName === eventArgs.category).cards
            .find(card => card.frontProduct.longSKU === eventArgs.longSKU).keys != null) {
          const keys = this.separatedProducts.find(c => c.categoryName === eventArgs.category)
            .cards.find(card => card.frontProduct.longSKU === eventArgs.longSKU).keys;
          this.separatedProducts.filter(category => category.cards.some(card => card.frontProduct.details.details
            .some(detail => detail.accessoryType === AccessoryCategory.Keys)))
            .forEach(category => {
              category.cards.forEach(card => {
                card.visible = keys.some(key => key === card.frontProduct.longSKU);
              });
              category.showNote = false;
            });
        }
      } else {
        this.separatedProducts.filter(category => category.cards.some(card =>
          card.frontProduct.details.details.some(detail => detail.accessoryType === AccessoryCategory.Keys)))
          .forEach(category => {
            category.cards.forEach(card => {
              card.visible = false;
            });
            category.showNote = true;
          });
      }
    }
    else if (eventArgs.accessoryType === AccessoryCategory.TPMS) {
      // set visibility of optional valves
      if (eventArgs.selected) {
        if (this.separatedProducts.some(c => c.categoryName === eventArgs.category)
          && this.separatedProducts.find(c => c.categoryName === eventArgs.category)
            .cards.some(card => card.frontProduct.longSKU === eventArgs.longSKU)
          && this.separatedProducts.find(c => c.categoryName === eventArgs.category)
            .cards.find(card => card.frontProduct.longSKU === eventArgs.longSKU).pairNo != null) {
          const pairNo = this.separatedProducts.find(c => c.categoryName === eventArgs.category)
            .cards.find(card => card.frontProduct.longSKU === eventArgs.longSKU).pairNo;
          const optionalValves = this.separatedProducts.filter(category => category.cards.some(card => card.frontProduct.details.details
            .some(detail => detail.accessoryType === AccessoryCategory.OptionalValves)));
          optionalValves.forEach(category => {
            category.cards.forEach(card => {
              card.visible = card.pairNo === pairNo;
            });
          });
        }
      } else {
        this.separatedProducts
          .filter(category => category.cards.some(card => card.frontProduct.details.details.some(
            detail => detail.accessoryType === AccessoryCategory.OptionalValves || detail.accessoryType === AccessoryCategory.TireValves)))
          .forEach(category => {
            category.cards.forEach(card => {
              card.visible = true;

              const valveProduct = new Product({
                id: card.frontProduct.longSKU,
                quantity: 0,
                warningNotes: null,
                type: Constants.PRODUCT_TYPE_HARDWARE,
                category: card.frontProduct.details.details[0].accessoryType,
                pairNo: card.pairNo
              });
              if (card.frontProduct.position !== null)
                valveProduct.position = card.frontProduct.position.toString();

              const valveSummaryProduct = new PackageBuilderSummaryProduct();
              valveSummaryProduct.shortSKU = card.frontProduct.shortSKU;
              valveSummaryProduct.qty = 0;
              valveSummaryProduct.accessoryType = card.frontProduct.details.details[0].accessoryType;
              valveSummaryProduct.pairNo = card.pairNo;
              if (card.frontProduct.position !== null)
                valveSummaryProduct.position = card.frontProduct.position.toString();

              this.packageBuilderService.removeHardware(valveProduct, valveSummaryProduct, Positions.FRONT);
            });
          });
      }
    }
    else if (eventArgs.accessoryType === AccessoryCategory.Mounting) {
      //this.log("onCardChanged Mounting - TPMS");
      this.separatedProducts
        .filter(category => category.cards.some(card => card.frontProduct.details.details.some(
          detail => detail.accessoryType === AccessoryCategory.TPMS)))
        .forEach(category => {
          category.cards.forEach(card => {
            if (card.wmbRequired)
              card.visible = eventArgs.selected;
          });
        });
    }
  }

  //toggleView() {
  //  this.recommendedView = !this.recommendedView;
  //  if (!this.recommendedView) {
  //    if (!this.separatedProducts.some(category => category.isActiveTab)) {
  //      this.separatedProducts[0].isActiveTab = true;
  //    }
  //  }
  //}


  getRecommendedProducts(): HardwareCategoryCards[] {
    return this.separatedProducts.filter(category => category.cards.some(card => card.recommended));
  }

  getCards(): GenericSummaryCardDtoResponse[] {
    if (this.separatedProducts.find(cat => cat.isActiveTab) != null &&
      this.separatedProducts.find(cat => cat.isActiveTab).cards.some(c => c.visible)) {
      return this.separatedProducts.find(cat => cat.isActiveTab).cards.filter(c => c.visible);
    }
    return new Array<GenericSummaryCardDtoResponse>();
  }

  showNote(): boolean {
    if (this.separatedProducts.find(cat => cat.isActiveTab) != null) {
      return this.separatedProducts.find(cat => cat.isActiveTab).showNote;
    }
    return false;
  }

  getNoteLabel(): string {
    if (this.separatedProducts.find(cat => cat.isActiveTab) != null) {
      return this.separatedProducts.find(cat => cat.isActiveTab).noteLabel;
    }
    return null;
  }


  getPageTitle(): string {
    const url = decodeURIComponent(this.router.url);
    if (url.includes("wheel-search"))
      return "FC.PackageBuilder.WheelsByVehicle";
    else
      return "FC.MakeYearModel.Label.PackageBuilder";
  }

  getKeyCards(keys: string[]): GenericSummaryCardDtoResponse[] {
    const results = new Array<GenericSummaryCardDtoResponse>();
    if (keys != null) {
      this.separatedProducts
        .filter(category => category.cards.some(c => c.frontProduct.details.details
          .some(detail => detail.accessoryType === AccessoryCategory.Keys)))
        .forEach(category => category.cards
          .forEach(c => {
            if (keys.some(key => key === c.frontProduct.longSKU)) {
              results.push(c);
            }
          })
        );
    }
    return results;
  }

  quoteQuote() {
    sessionStorage.setItem("isQuote", "yes");
    const packageBuilderService = this.injector.get<PackageBuilderService>(PackageBuilderService);
    const product: Product = new Product();
    let frontProduct = null;
    let rearProduct = null;
    let frontSummaryProduct = null;
    let rearSummaryProduct = null;
    let frontWheelID = null;
    let frontWheelQty = null;
    let frontWheelTitle = null;
    let frontWheelDetails = null;
    let frontWheelLongSKU = null;
    let frontWheelShortSKU = null;
    let frontWheelImageURL = null;
    let frontWheelCustomerPrice = null;
    let frontwheelnotes: string = null;
    let frontTireID = null;
    let frontTireQty = null;
    let frontTireTitle = null;
    let frontTireDetails = null;
    let frontTireLongSKU = null;
    let frontTireShortSKU = null;
    let frontTireImageURL = null;
    let frontTireCustomerPrice = null;
    let fronttirepressure = null;
    let reartirepressure = null;
    let rearWheelID = null;
    let rearWheelQty = null;
    let rearWheelTitle = null;
    let rearWheelDetails = null;
    let rearWheelLongSKU = null;
    let rearWheelShortSKU = null;
    let rearWheelImageURL = null;
    let rearWheelCustomerPrice = null;
    let rearTireID = null;
    let rearTireQty = null;
    let rearTireTitle = null;
    let rearTireDetails = null;
    let rearTireLongSKU = null;
    let rearTireShortSKU = null;
    let rearTireImageURL = null;
    let rearTireCustomerPrice = null;

    // tslint:disable djb: disable all rules until enable

    if (this.url.includes("frontwheelid")) {
      frontWheelID = this.url.substring(this.url.indexOf("frontwheelid") + 12, this.url.lastIndexOf("frontwheelid"));
      frontWheelQty = parseInt(this.url.substring(this.url.indexOf("frontwheelqty") + 13, this.url.lastIndexOf("frontwheelqty")));
      frontWheelTitle = this.url.substring(this.url.indexOf("frontwheeltitle") + 15, this.url.lastIndexOf("frontwheeltitle"));
      frontWheelDetails = this.url.substring(this.url.indexOf("frontwheeldetails") + 17, this.url.lastIndexOf("frontwheeldetails"));
      frontWheelLongSKU = this.url.substring(this.url.indexOf("frontwheellongsku") + 17, this.url.lastIndexOf("frontwheellongsku"));
      frontWheelShortSKU = this.url.substring(this.url.indexOf("frontwheelshortsku") + 18, this.url.lastIndexOf("frontwheelshortsku"));
      frontWheelImageURL = this.url.substring(this.url.indexOf("frontwheelimageurl") + 18, this.url.lastIndexOf("frontwheelimageurl"));
      frontWheelCustomerPrice = this.url.substring(this.url.indexOf("frontwheelcustomerprice") + 23, this.url.lastIndexOf("frontwheelcustomerprice"));
      frontwheelnotes = this.url.substring(this.url.indexOf("frontwheelnotes") + 15, this.url.lastIndexOf("frontwheelnotes"));
    }

    if (this.url.includes("fronttireid")) {
      frontTireID = this.url.substring(this.url.indexOf("fronttireid") + 11, this.url.lastIndexOf("fronttireid"));
      frontTireQty = parseInt(this.url.substring(this.url.indexOf("fronttireqty") + 12, this.url.lastIndexOf("fronttireqty")));
      frontTireTitle = this.url.substring(this.url.indexOf("fronttiretitle") + 14, this.url.lastIndexOf("fronttiretitle"));
      frontTireDetails = this.url.substring(this.url.indexOf("fronttiredetails") + 16, this.url.lastIndexOf("fronttiredetails"));
      frontTireLongSKU = this.url.substring(this.url.indexOf("fronttirelongsku") + 16, this.url.lastIndexOf("fronttirelongsku"));
      frontTireShortSKU = this.url.substring(this.url.indexOf("fronttireshortsku") + 17, this.url.lastIndexOf("fronttireshortsku"));
      frontTireImageURL = this.url.substring(this.url.indexOf("fronttireimageurl") + 17, this.url.lastIndexOf("fronttireimageurl"));
      frontTireCustomerPrice = this.url.substring(this.url.indexOf("fronttirecustomerprice") + 22, this.url.lastIndexOf("fronttirecustomerprice"));
      fronttirepressure = this.url.substring(this.url.indexOf("fronttirepressure") + 17, this.url.lastIndexOf("fronttirepressure"));
      reartirepressure = this.url.substring(this.url.indexOf("reartirepressure") + 16, this.url.lastIndexOf("reartirepressure"));
    }

    if (this.url.includes("rearwheelid")) {
      rearWheelID = this.url.substring(this.url.indexOf("rearwheelid") + 11, this.url.lastIndexOf("rearwheelid"));
      rearWheelQty = parseInt(this.url.substring(this.url.indexOf("rearwheelqty") + 12, this.url.lastIndexOf("rearwheelqty")));
      rearWheelTitle = this.url.substring(this.url.indexOf("rearwheeltitle") + 14, this.url.lastIndexOf("rearwheeltitle"));
      rearWheelDetails = this.url.substring(this.url.indexOf("rearwheeldetails") + 16, this.url.lastIndexOf("rearwheeldetails"));
      rearWheelLongSKU = this.url.substring(this.url.indexOf("rearwheellongsku") + 16, this.url.lastIndexOf("rearwheellongsku"));
      rearWheelShortSKU = this.url.substring(this.url.indexOf("rearwheelshortsku") + 17, this.url.lastIndexOf("rearwheelshortsku"));
      rearWheelImageURL = this.url.substring(this.url.indexOf("rearwheelimageurl") + 17, this.url.lastIndexOf("rearwheelimageurl"));
      rearWheelCustomerPrice = this.url.substring(this.url.indexOf("rearwheelcustomerprice") + 22, this.url.lastIndexOf("rearwheelcustomerprice"));
    }

    if (this.url.includes("reartireid")) {
      rearTireID = this.url.substring(this.url.indexOf("reartireid") + 10, this.url.lastIndexOf("reartireid"));
      rearTireQty = parseInt(this.url.substring(this.url.indexOf("reartireqty") + 11, this.url.lastIndexOf("reartireqty")));
      rearTireTitle = this.url.substring(this.url.indexOf("reartiretitle") + 10, this.url.lastIndexOf("reartiretitle"));
      rearTireDetails = this.url.substring(this.url.indexOf("reartiredetails") + 10, this.url.lastIndexOf("reartiredetails"));
      rearTireLongSKU = this.url.substring(this.url.indexOf("reartirelongsku") + 10, this.url.lastIndexOf("reartirelongsku"));
      rearTireShortSKU = this.url.substring(this.url.indexOf("reartireshortsku") + 10, this.url.lastIndexOf("reartireshortsku"));
      rearTireImageURL = this.url.substring(this.url.indexOf("reartireimageurl") + 10, this.url.lastIndexOf("reartireimageurl"));
      rearTireCustomerPrice = this.url.substring(this.url.indexOf("reartirecustomerprice") + 10, this.url.lastIndexOf("reartirecustomerprice"));
    }

    var warningArray = [];
    var start = 0;
    var end = 0;
    for (var i = 0; i < frontwheelnotes.length; i++) {
      if (frontwheelnotes[i] === "|") {
        end = i;
        warningArray.push(frontwheelnotes.substring(start, end));
        start = i + 1;
      }
    }

    if (frontWheelID != null && frontWheelQty != null) {
      frontProduct = this.createProduct(frontWheelID, frontWheelQty, warningArray, "Wheels", rearWheelLongSKU != null ? `${frontWheelLongSKU}_${rearWheelLongSKU}` : "", null, rearWheelID != null && rearWheelQty != null ? "F" : "B");
      frontSummaryProduct = this.summaryFromCard(frontWheelLongSKU, frontWheelShortSKU, frontWheelImageURL, frontWheelCustomerPrice, frontWheelQty, "Wheels", frontWheelTitle, frontWheelDetails, warningArray, rearWheelLongSKU != null ? `${frontWheelLongSKU}_${rearWheelLongSKU}` : "", rearWheelID != null && rearWheelQty != null ? "F" : "B");
    } else {
      frontProduct = null;
      frontSummaryProduct = null;
    }

    if (rearWheelID != null && rearWheelQty != null) {
      rearProduct = this.createProduct(rearWheelID, rearWheelQty, null, "Wheels", rearWheelLongSKU != null ? `${frontWheelLongSKU}_${rearWheelLongSKU}` : "", null, "R");
      rearSummaryProduct = this.summaryFromCard(rearWheelLongSKU, rearWheelShortSKU, rearWheelImageURL, rearWheelCustomerPrice, rearWheelQty, "Wheels", rearWheelTitle, rearWheelDetails, null, rearWheelLongSKU != null ? `${frontWheelLongSKU}_${rearWheelLongSKU}` : "", "R");
    } else {
      rearProduct = null;
      rearSummaryProduct = null;
    }

    packageBuilderService.addProduct(
      frontProduct,
      frontSummaryProduct,
      rearProduct,
      rearSummaryProduct,
      false, "Wheels"
    );

    let tirePressureArray = [];
    tirePressureArray.push(fronttirepressure);
    tirePressureArray.push(reartirepressure);

    if (frontTireID != null && frontTireQty != null) {
      frontProduct = this.createProduct(frontTireID, frontTireQty, tirePressureArray, "Tires", rearTireLongSKU != null ? `${frontTireLongSKU}_${rearTireLongSKU}` : "", null, rearTireID != null && rearTireQty != null ? "F" : "B");
      frontSummaryProduct = this.summaryFromCard(frontTireLongSKU, frontTireShortSKU, frontTireImageURL, frontTireCustomerPrice, frontTireQty, "Tires", frontTireTitle, frontTireDetails, null, rearTireLongSKU != null ? `${frontTireLongSKU}_${rearTireLongSKU}` : "", rearTireID != null && rearTireQty != null ? "F" : "B");
    } else {
      frontProduct = null;
      frontSummaryProduct = null;
    }

    if (rearTireID != null && rearTireQty != null) {
      rearProduct = this.createProduct(rearTireID, rearTireQty, null, "Tires", rearTireLongSKU != null ? `${frontTireLongSKU}_${rearTireLongSKU}` : "", null, "R");
      rearSummaryProduct = this.summaryFromCard(rearTireLongSKU, rearTireShortSKU, rearTireImageURL, rearTireCustomerPrice, rearTireQty, "Tires", rearTireTitle, rearTireDetails, null, rearTireLongSKU != null ? `${frontTireLongSKU}_${rearTireLongSKU}` : "", "R");
    } else {
      rearProduct = null;
      rearSummaryProduct = null;
    }

    packageBuilderService.addProduct(
      frontProduct,
      frontSummaryProduct,
      rearProduct,
      rearSummaryProduct,
      false, "Tires"
    );

    for (var i = 1; i <= 18; i++) {
      if (this.url.includes("accessory" + i + "id")) {
        if (i < 10) {
          var longSKU = this.url.substring(this.url.indexOf("accessory" + i + "id") + 12, this.url.lastIndexOf("accessory" + i + "id"));
          var imageURL = this.url.substring(this.url.indexOf("accessory" + i + "imageurl") + 18, this.url.lastIndexOf("accessory" + i + "imageurl"));
          var shortSKU = this.url.substring(this.url.indexOf("accessory" + i + "shortsku") + 18, this.url.lastIndexOf("accessory" + i + "shortsku"));
          var quantity = parseInt(this.url.substring(this.url.indexOf("accessory" + i + "qty") + 13, this.url.lastIndexOf("accessory" + i + "qty")));
          var price = this.url.substring(this.url.indexOf("accessory" + i + "customerprice") + 23, this.url.lastIndexOf("accessory" + i + "customerprice"));
          var title = this.url.substring(this.url.indexOf("accessory" + i + "title") + 15, this.url.lastIndexOf("accessory" + i + "title"));
        } else {
          var longSKU = this.url.substring(this.url.indexOf("accessory" + i + "id") + 13, this.url.lastIndexOf("accessory" + i + "id"));
          var imageURL = this.url.substring(this.url.indexOf("accessory" + i + "imageurl") + 19, this.url.lastIndexOf("accessory" + i + "imageurl"));
          var shortSKU = this.url.substring(this.url.indexOf("accessory" + i + "shortsku") + 19, this.url.lastIndexOf("accessory" + i + "shortsku"));
          var quantity = parseInt(this.url.substring(this.url.indexOf("accessory" + i + "qty") + 14, this.url.lastIndexOf("accessory" + i + "qty")));
          var price = this.url.substring(this.url.indexOf("accessory" + i + "customerprice") + 24, this.url.lastIndexOf("accessory" + i + "customerprice"));
          var title = this.url.substring(this.url.indexOf("accessory" + i + "title") + 16, this.url.lastIndexOf("accessory" + i + "title"));
        }
        // jl: missing front and rear accessories
        var pairNo = "";// rearAccessoryLongSKU != null ? `${frontAccessoryLongSKU}_${rearAccessoryLongSKU}` : "";
        this.updateHardware(longSKU, quantity, shortSKU, imageURL, title, price, pairNo, null, null);
      }
    }
  }

  // djb:hack-bypass hardware-test, setup category tabs without it
  private showNavTabs() {
    if (document.getElementById('tirParent') === null) {
      this.log("showNavTabs: can't find tire parent!");
      return;
    }
    // djb:doc-inital states
    var keyParent = true;
    var capParent = true;
    var bolParent = false;
    var lboParent = true;
    var lnuParent = false;
    var tvaParent = true;
    var insParent = false;
    var rivParent = false;
    var stuParent = false;
    var mouParent = false;
    var rinParent = true;
    var hubParent = false;
    var nutParent = false;
    var tpmParent = false;
    var valParent = false;
    var tirParent = !window.location.href.toLowerCase().includes("wheel-search");
    var kitParent = User.showPackageKit;
    var diaParent = false;

    if (this.separatedProducts) {
      if (this.separatedProducts.length > 0) {
        keyParent = false;
        capParent = false;
        bolParent = false;
        lboParent = false;
        lnuParent = false;
        tvaParent = false;
        insParent = false;
        rivParent = false;
        stuParent = false;
        mouParent = false;
        rinParent = false;
        hubParent = false;
        nutParent = false;
        tpmParent = false;
        valParent = false;
        diaParent = false;
        this.separatedProducts.forEach(cat => {
          this.log(`showNavTabs: catId ${cat.catId}-${cat.categoryName} (${cat.cards.length})`);
          switch (cat.catId) {
            case AccessoryCategory.HubCaps:
              hubParent = true;
              break;
            case AccessoryCategory.CenterCaps:
              capParent = true;
              break;
            case AccessoryCategory.Inserts:
              insParent = true;
              break;
            case AccessoryCategory.Rivets:
              rivParent = true;
              break;
            case AccessoryCategory.Studding:
              stuParent = true;
              break;
            case AccessoryCategory.HubRings:
              rinParent = true;
              break;
            case AccessoryCategory.Nuts:
              nutParent = true;
              break;
            case AccessoryCategory.Bolts:
              bolParent = true;
              break;
            case AccessoryCategory.Keys:
            case AccessoryCategory.LockKey:
              keyParent = true;
              break;
            case AccessoryCategory.LockBolts:
              lboParent = true;
              break;
            case AccessoryCategory.LockNuts:
              lnuParent = true;
              break;
            case AccessoryCategory.Mounting:
              mouParent = true;
              break;
            case AccessoryCategory.TireValves:
              tvaParent = this.packageBuilderService.showValvesTab();
              break;
            case AccessoryCategory.OptionalValves:
              valParent = !this.packageBuilderService.showValvesTab() && this.separatedProducts.some(category => category.cards.some(card => card.frontProduct.details.details.some(d => d.accessoryType === AccessoryCategory.OptionalValves) && card.visible));
              break;
            case AccessoryCategory.TPMS:
              tpmParent = true;
              break;
            case AccessoryCategory.InstallationKit:
              if (User.showInstallationKitsTab) {
                diaParent = true;
              }
              break;
            default:
              this.log(`showNavTabs: ***Missing Tab Id: ${cat.catId}`);
          }
        });
      }
    }
    document.getElementById('tirParent').style.display = tirParent ? "block" : "none";
    document.getElementById('keyParent').style.display = keyParent ? "block" : "none";
    document.getElementById('capParent').style.display = capParent ? "block" : "none";
    document.getElementById('bolParent').style.display = bolParent ? "block" : "none";
    document.getElementById('lboParent').style.display = lboParent ? "block" : "none";
    document.getElementById('lnuParent').style.display = lnuParent ? "block" : "none";
    document.getElementById('tvaParent').style.display = tvaParent ? "block" : "none";
    document.getElementById('insParent').style.display = insParent ? "block" : "none";
    document.getElementById('rivParent').style.display = rivParent ? "block" : "none";
    document.getElementById('kitParent').style.display = kitParent ? "block" : "none";
    document.getElementById('diaParent').style.display = diaParent ? "block" : "none";
    //Added two tabs for Studding differently (TireFirst/WheelFirst) because activePBFlow is not working properly for click
    //When user changes the Preference Type i.e. From WheelFirst to TireFirst or viceversa
    //Other solution is Refresh the whole page.
    if (this.tiresFirst) {
      document.getElementById('stuFParent').style.display = stuParent ? "block" : "none";
      document.getElementById('stuParent').style.display = "none";
    }
    else {
      document.getElementById('stuParent').style.display = stuParent ? "block" : "none";
      document.getElementById('stuFParent').style.display = "none";
    }
    document.getElementById('mouParent').style.display = mouParent ? "block" : "none";
    document.getElementById('rinParent').style.display = rinParent ? "block" : "none";
    document.getElementById('hubParent').style.display = hubParent ? "block" : "none";
    document.getElementById('nutParent').style.display = nutParent ? "block" : "none";
    document.getElementById('valParent').style.display = valParent ? "block" : "none";
    // djb:note-oem related tabs
    document.getElementById('nutParent').style.display = this.oemData.boltNut === "N" ? "block" : "none";
    document.getElementById('bolParent').style.display = this.oemData.boltNut === "B" ? "block" : "none";
    if (this.packageBuilderService.wheelIsDirectFit) {
      this.nutLocalisationKey = "FC.PackageBuilder.Nuts.Optional";
    }
    else {
      this.nutLocalisationKey = "FC.PackageBuilder.Nuts";
    }
    // djb:bug-what if not oemData.isTMPSEquipped but separatedProducts include TPMS?
    let tpmsType = this.oemData.groups.find(g => g.groupName === 'TPMSLoad')
      .items.find(i => i.itemName === 'Tpms').itemValue;
    tpmParent = this.oemData.isTPMSEquipped && tpmsType != 'Indirect' // || tpmParent
    document.getElementById('tpmParent').style.display = tpmParent ? "block" : "none";
  }

  private flowToNextTab() {
    const nextTabParent = $('.b2b-nav-tabs li a.activePBFlow').parent('li').nextAll(":visible").first();
    if (nextTabParent.length > 0) {
      let nextTab = nextTabParent[0].id.replace('Parent', '');
      let nextTabAfter = $('.b2b-nav-tabs li a.activePBFlow').parent('li').nextAll(":visible")[1].id.replace('Parent', '');
      this.log(`flowToNextTab: before skipOverTab: nextTab=${nextTab} nextTabAfter=${nextTabAfter}`);
      nextTab = this.skipOverTab(nextTab, nextTabAfter);
      sessionStorage.setItem('flowToNextTab', nextTab);
      let lastTabName = sessionStorage.getItem('lastTabName')
      let lastTabId = sessionStorage.getItem('lastTabId')
      this.log(`flowToNextTab: after skipOverTab: ${nextTab}.click lastTabName: ${lastTabName} lastTabId: ${lastTabId}`);
      //djb:hack to restore lastTabName state afterAll language change
      if (lastTabName === 'i18n') {
        this.packageBuilderService.changeTab('i18n Step2', +lastTabId);
        Helper.setActiveTabState(Helper.activeTab);
      } else {
        document.getElementById(nextTab).click();
      }
    }
  }

  private skipOverTab(thisTab, nextTab): string {
    // djb:uiLogic-caps come in box, so skip over caps to next available tab 
    if (thisTab === 'cap') {
      let capCards = this.cards.filter(c => c.frontProduct.details.details.some(d => d.accessoryType === AccessoryCategory.CenterCaps));
      let atLeastOneCapInBox = capCards.some(a => a.type != null && a.type.toLowerCase().startsWith("std"));
      let atLeastOneCapAvailableForPurchase = capCards.some(a => a.type != null && !a.type.toLowerCase().startsWith("std"));
      let extensionCapAdded = capCards.some(a => a.type != null && !a.type.toLowerCase().startsWith("ext")) &&
        sessionStorage.getItem("ExtensionCap") === "yes" &&
        sessionStorage.getItem("ExtensionCapRemovedByUser") === "no";
      let atLeastOneOECapWithSameBrandAsWheel = capCards.some(a => {
        if (a.type != null && a.type.toLowerCase().startsWith("oe")) {
          let wheelBrand = this.packageBuilderService.wheelBrand;
          let capPairNo = null;
          if (a.pairNo != null)
            capPairNo = a.pairNo.split("_");
          let capBrand = null;
          if (capPairNo != null && capPairNo.length > 2)
            capBrand = capPairNo[2];
          if (capBrand != null && wheelBrand != null && capBrand === wheelBrand)
            return true;
          return false;
        }
        return false;
      });
      if (atLeastOneCapInBox && (!atLeastOneCapAvailableForPurchase || extensionCapAdded || atLeastOneOECapWithSameBrandAsWheel)) {
        thisTab = nextTab;
        this.log(`skipCapsTab: from ${thisTab} to ${nextTab}`);
      }
    }

    return thisTab;
  }

  private AddPagingParams(type: string, mymQueryParams: object) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const paramValue = urlParams.get('page');
    const sizeParamValue = urlParams.get('pageSize');
    let pm: PageModel = null;
    const p = sessionStorage.getItem(`${type}Paging`);
    if (p !== null) {
      pm = JSON.parse(p);
      //sessionStorage.removeItem(`${type}Paging`)
    }
    if (pm !== null) {
      if (pm.page !== null)
        mymQueryParams[Constants.PAGE_PARAM] = paramValue != "1" ? pm.page : "1";
      //mymQueryParams[Constants.PAGE_PARAM] = pm.page;
      if (pm.pageSize !== null)
        mymQueryParams[Constants.PAGE_SIZE_PARAM] = sizeParamValue === null ? sizeParamValue : pm.pageSize;
      if (pm.pageSize !== null)
        mymQueryParams[Constants.ORDER_BY_PARAM] = pm.orderBy;
    }
    else {
      if (paramValue !== null)
        mymQueryParams[Constants.PAGE_PARAM] = paramValue != "1" ? "1" : paramValue;
    }
  }

  private navigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    this.log(`router.navigate: ${commands} ${JSON.stringify(extras.queryParams)}`);
    return this.router.navigate(commands, extras);
  }

  //djb:diagnostics specific to this component
  private log(msg: string) {
    Helper.log(`PackageBuilderComponent[${this.id}].${msg}`);
  }
  get isFastcoUser(): boolean {
    return User.isFastcoRole;
  }

  private verifyIsProductValid(summary: PackageBuilderSummaryProduct): boolean {
    return this.packageBuilderService.verifyIsProductValid(summary) && summary.longSKU !== null && summary.longSKU !== '';
  }
}

